// extracted by mini-css-extract-plugin
export default {"introduction":"Purpose_introduction__Z8U9L","img":"Purpose_img__bmnMc","text-container":"Purpose_text-container__d--Y+","text-emphasize":"Purpose_text-emphasize__Jz59W"};